var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"small text-center",staticStyle:{"margin-bottom":"15px"}},[_c('p',[_vm._v("Powered by Robolingo Co., Ltd.")]),_vm._v("\n    Contact Us: "),_c('a',{attrs:{"href":'mailto:' + _vm.$store.state.theme.email_contact}},[_vm._v(_vm._s(_vm.$store.state.theme.email_contact)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a74c6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/footer.vue
// module id = null
// module chunks = 